export const FETCH_COLLECTIONS_REQUEST = "fetch/collections/request";
export const FETCH_COLLECTIONS_SUCCESS = "fetch/collections/success";
export const FETCH_COLLECTIONS_FAILURE = "fetch/collections/failure";
